
export const projectTypes = [
  {
    __caslSubjectType__: "Project",
    name: "Connect Existing Store",
    hint: 'For Shopify, Woocommerce, Magento and others',
    type: "ECOMMERCE",
    enabled: true,
    langId: "project.ecommerce",
    featureName: "ecommerceProject",
    image: 'https://assets.bitbute.tech/public/projects/Ecommerce.jpeg'
  },
  {
    __caslSubjectType__: "Project",
    name: "Create New Store",
    hint: 'For Self Hosting',
    enabled: true,
    type: "PRODUCT_VISUALIZER",
    langId: "project.product-visualizer",
    featureName: "productVisualizerProject",
    image: 'https://assets.bitbute.tech/public/projects/Product%20Visualizer.jpeg'
  },
  {
    __caslSubjectType__: "Project",
    name: "AR Card",
    type: "AR_CARD",
    langId: "project.ar-card",
    featureName: "arCardProject",
    image: 'https://assets.bitbute.tech/public/projects/AR%20Card.jpeg'
  },
];

export const getProjectType = (type) => {
  const projectType = projectTypes.find((project) => project.type === type);
  return projectType ? projectType : "N/A";
};
